import * as React from 'react';
import { cn } from '@/lib/utils';

const ReportKpiWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-report-kpi-wrapper',
      // styles
      'mb-8 grid grid-cols-[repeat(auto-fill,minmax(min(100%,300px),1fr))] gap-5 border-b border-solid border-neutral-lightest pb-12',
      className
    )}
    {...props}
  />
));
ReportKpiWrapper.displayName = 'ReportKpiWrapper';

const ReportKpi = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-report-kpi',
      // styles
      'flex flex-col gap-4 rounded-[10px] border-[2px] border-solid border-neutral-bright bg-[linear-gradient(10deg,#FFF_20.02%,#F5F5F5_85.13%)] p-5 shadow-dropshadow-lg',
      className
    )}
    {...props}
  />
));
ReportKpi.displayName = 'ReportKpi';

const ReportKpiHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-report-kpi-header',
      // styles
      'flex items-center gap-3',
      className
    )}
    {...props}
  />
));
ReportKpiHeader.displayName = 'ReportKpiHeader';

const ReportKpiIcon = React.forwardRef(({ className, alt = '', ...props }, ref) => (
  <img
    ref={ref}
    className={cn(
      'c-report-kpi-icon',
      // styles
      'h-[36px] w-[50px] shrink-0 object-contain',
      className
    )}
    alt={alt}
    {...props}
  />
));
ReportKpiIcon.displayName = 'ReportKpiIcon';

const ReportKpiTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h4
    ref={ref}
    className={cn(
      'c-report-kpi-title',
      // styles
      'mb-0 text-[14px] font-bold text-primary-dark',
      className
    )}
    {...props}
  />
));
ReportKpiTitle.displayName = 'ReportKpiTitle';

const ReportKpiBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-report-kpi-body',
      // styles
      className
    )}
    {...props}
  />
));
ReportKpiBody.displayName = 'ReportKpiBody';

const ReportKpiValue = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-report-kpi-value',
      // styles
      'mb-0 text-[42px] font-extrabold leading-[1.2] text-primary-light',
      className
    )}
    {...props}
  />
));
ReportKpiValue.displayName = 'ReportKpiValue';

export { ReportKpiWrapper, ReportKpi, ReportKpiHeader, ReportKpiIcon, ReportKpiTitle, ReportKpiBody, ReportKpiValue };
